import {make} from "vuex-pathify"

const state = {
    isLoading: false,
    // Users with access tokens
    page: {
        data: [],
        meta: {}
    },
    // Selected user
    form: {},
    // Tokens of the selected user
    tokensPage: {
        data: [],
        meta: {}
    }
}

const mutations = make.mutations(state)

const actions = {
    loading({commit}) {
        commit('SET_IS_LOADING', true)
    },
    loaded({commit}) {
        commit('SET_IS_LOADING', false)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
